export function downloadFromUrl(url: string, fileName: string) {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export function downloadTextFile(content: string, fileName: string, mimeType: string) {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    downloadFromUrl(url, fileName);
    URL.revokeObjectURL(url);
}
export function downloadFromBlob(blob: Blob, fileName: string) {
    const url = URL.createObjectURL(blob);
    downloadFromUrl(url, fileName);
    URL.revokeObjectURL(url);
}
